import * as React from 'react';
import AppUtils from '../utils/AppUtils';
import '../sass/SettingsComponent.css';
import { Fade, ControlLabel, DropdownButton, MenuItem, Form, FormGroup, Col, FormControl, Checkbox, Button, OverlayTrigger, Popover } from 'react-bootstrap';
import AppConfig from 'src/config/AppConfig';
import Settings from 'src/objects/Settings';

export default class SettingsComponent extends React.Component<any, any> {
    
    private text:any = this.props.text;
    private settings:Settings = this.props.settings;

    constructor(props:any) {
        super(props);

        this.state = {
            visible: false,
            text: this.text,
            settings: this.settings,
            canSave: false,
        }

        this.show = this.show.bind(this);
        this.hide = this.hide.bind(this);

        console.log("Showing settings diagram");
    }

    private show() {
        this.setState({visible: true})
    }

    private hide() {
        this.setState({visible: false})
    }

    private canShow():boolean {
      if (!AppUtils.isMobile) {
        return true;
      }
      return false;
    }

    private onUpdateintroHeader(e:any) {
        e.preventDefault();
        let text = this.state.text;
        text.landing.subHeading = e.target.value;
        this.setState({text: text, canSave:true});
    }

    private onUpdateIntroTitle(e:any) {
        e.preventDefault();
        let text = this.state.text;
        text.landing.title = e.target.value;
        this.setState({text: text, canSave:true});
    }

    private onUpdateIntroDescription(e:any) {
        e.preventDefault();
        let text = this.state.text;
        text.landing.description = e.target.value;
        this.setState({text: text, canSave:true});
    }

    private onUpdateGameEndingSuccess(e:any) {
        e.preventDefault();
        let text = this.state.text;
        text.game.gameOver = e.target.value;
        this.setState({text: text, canSave:true});
    }

    private onUpdateGameEndingFail(e:any) {
        e.preventDefault();
        let text = this.state.text;
        text.game.playerDied = e.target.value;
        this.setState({text: text, canSave:true});
    }

    // private handleCurrencySelect(eventKey: any, e: any) {
    //     let settings = this.state.settings;
    //     settings.currency = e.target.text;
    //     this.setState({settings: settings, canSave:true});
    // }

    private handleVehicleSelect(eventKey: any, e: any) {
        let settings:Settings = this.state.settings;
        settings.vehicle = e.target.text;
        this.setState({settings: settings, canSave:true});
    }

    private handleThemeSelect(eventKey: any, e: any) {
        let settings:Settings = this.state.settings;
        settings.theme = e.target.text;
        this.setState({settings: settings, canSave:true});
    }

    private handleStatSelect(eventKey: any, e: any) {
        let settings:Settings = this.state.settings;
        settings.stat = e.target.text;
        this.setState({settings: settings, canSave:true});
    }

    // private getSaveClass():string {
    //     let saveBtnClass:string = "saveBtn";
    //     if (this.state.canSave == false) {
    //         saveBtnClass = "saveBtnOff";
    //     }
    //     return saveBtnClass;
    // }

    private saveSettings():void {
        if (this.state.canSave) {
            this.props.settingsDatabaseRef.set(this.state.settings);
            this.props.textDatabaseRef.set(this.state.text);
            this.setState({canSave:false});
        }
    }

    private onUpdateSettingsPrefix(e:any):void {
        e.preventDefault();
        let settings:Settings = this.state.settings;
        settings.prefix = e.target.value;
        this.setState({settings: settings, canSave:true});
    }

    private onUpdateSettingsSuffix(e:any):void {
        e.preventDefault();
        let settings:Settings = this.state.settings;
        settings.suffix = e.target.value;
        this.setState({settings: settings, canSave:true});
    }

    private onUpdateSettingsStartingStat(e:any):void {
        e.preventDefault();
        let settings:Settings = this.state.settings;
        settings.startingStat = e.target.value;
        let startingStatFloat = parseFloat(e.target.value)
        this.setState({settings: settings, canSave:!isNaN(startingStatFloat)});
    }

    private onUpdateSettingsMinStat(e:any):void {
        e.preventDefault();
        let settings:Settings = this.state.settings;
        settings.minStat = e.target.value;
        let minStatFloat = parseFloat(e.target.value)
        this.setState({settings: settings, canSave:!isNaN(minStatFloat)});
    }

    private onUpdateSettingsMaxStat(e:any):void {
        e.preventDefault();
        let settings:Settings = this.state.settings;
        settings.maxStat = e.target.value;
        let maxStatFloat = parseFloat(e.target.value)
        this.setState({settings: settings, canSave:!isNaN(maxStatFloat)});
    }

    private onUpdateImpactHuge(e:any):void {
        e.preventDefault();
        let settings:Settings = this.state.settings;
        settings.impactStatValues.huge = parseInt(e.target.value);
        this.setState({settings: settings, canSave:true});
    }

    private onUpdateImpactLarge(e:any):void {
        e.preventDefault();
        let settings:Settings = this.state.settings;
        settings.impactStatValues.large = parseInt(e.target.value);
        this.setState({settings: settings, canSave:true});
    }

    private onUpdateImpactMedium(e:any):void {
        e.preventDefault();
        let settings:Settings = this.state.settings;
        settings.impactStatValues.medium = parseInt(e.target.value);
        this.setState({settings: settings, canSave:true});
    }

    private onUpdateImpactSmall(e:any):void {
        e.preventDefault();
        let settings:Settings = this.state.settings;
        settings.impactStatValues.small = parseInt(e.target.value);
        this.setState({settings: settings, canSave:true});
    }

    private onUpdateImpactTiny(e:any):void {
        e.preventDefault();
        let settings:Settings = this.state.settings;
        settings.impactStatValues.tiny = parseInt(e.target.value);
        this.setState({settings: settings, canSave:true});
    }

    render() {
        return (
            <Fade in={this.canShow()} onEntering={this.show}>
            <div id='settingsContainer' className="pageContainer">
                <div id="header">
                    <h2 className="pageHeader">Settings</h2>
                </div>
                <div className='settingsGroup'>
                    <Form horizontal>
                        <FormGroup controlId="formHorizontalEmail">
                            <Col className="settingsLabel" sm={2}>
                                <OverlayTrigger
                                    trigger={['hover', 'focus']}
                                    key="themeOverlay"
                                    placement="top"
                                    overlay={
                                        <Popover id="popover-positioned-top">Current version</Popover>
                                    }>
                                    <span>Version</span>
                                </OverlayTrigger>
                            </Col>
                            <Col id="appBuildNumber" sm={10}>
                                <span>{AppConfig.BUILD_NUMBER}</span>
                            </Col>
                        </FormGroup>
                        <FormGroup controlId="formHorizontalEmail">
                            <Col className="settingsLabel" sm={2}>
                                <OverlayTrigger
                                    trigger={['hover', 'focus']}
                                    key="themeOverlay"
                                    placement="top"
                                    overlay={
                                        <Popover id="popover-positioned-top">Set the game style</Popover>
                                    }>
                                    <span>Theme</span>
                                </OverlayTrigger>
                            </Col>
                            <Col sm={10}>
                                <DropdownButton
                                    bsStyle="default"
                                    className="whiteDropdown"
                                    title={this.state.settings.theme}
                                    key="themeDropdown"
                                    id="dropdown-basic-default"
                                    >
                                    <MenuItem onSelect={this.handleThemeSelect.bind(this)} eventKey="1">{AppConfig.SETTINGS_THEME_NAMES.cityHunter}</MenuItem>
                                    <MenuItem onSelect={this.handleThemeSelect.bind(this)} eventKey="2">{AppConfig.SETTINGS_THEME_NAMES.treasureHunter}</MenuItem>
                                    <MenuItem onSelect={this.handleThemeSelect.bind(this)} eventKey="3">{AppConfig.SETTINGS_THEME_NAMES.cyberSecurity}</MenuItem>
                                    <MenuItem disabled eventKey="3">{AppConfig.SETTINGS_THEME_NAMES.army}</MenuItem>
                                    <MenuItem disabled eventKey="4">{AppConfig.SETTINGS_THEME_NAMES.bridgeBuilder}</MenuItem>
                                    <MenuItem disabled eventKey="5">{AppConfig.SETTINGS_THEME_NAMES.construction}</MenuItem>
                                    <MenuItem disabled eventKey="6">{AppConfig.SETTINGS_THEME_NAMES.hospital}</MenuItem>
                                    <MenuItem disabled eventKey="7">{AppConfig.SETTINGS_THEME_NAMES.marsExploration}</MenuItem>
                                    <MenuItem disabled eventKey="8">{AppConfig.SETTINGS_THEME_NAMES.office}</MenuItem>
                                    <MenuItem disabled eventKey="9">{AppConfig.SETTINGS_THEME_NAMES.school}</MenuItem>
                                </DropdownButton>
                            </Col>
                        </FormGroup>
                        {
                            this.state.settings.theme == AppConfig.SETTINGS_THEME_NAMES.cityHunter ? 
                            <FormGroup controlId="formHorizontalEmail">
                                <Col className="settingsLabel" sm={2}>
                                    <OverlayTrigger
                                        trigger={['hover', 'focus']}
                                        key="themeOverlay"
                                        placement="top"
                                        overlay={
                                            <Popover id="popover-positioned-top">Choose the main character or vehicle</Popover>
                                        }>
                                        <span>Vehicle</span>
                                    </OverlayTrigger>
                                </Col>
                                <Col sm={10}>
                                    <DropdownButton
                                        bsStyle="default"
                                        className="whiteDropdown"
                                        title={this.state.settings.vehicle}
                                        key="themeDropdown"
                                        id="dropdown-basic-default"
                                        >
                                        <MenuItem eventKey="1" onSelect={this.handleVehicleSelect.bind(this)}>{AppConfig.SETTINGS_VEHICLE_NAMES.Ambulance}</MenuItem>
                                        <MenuItem eventKey="2" onSelect={this.handleVehicleSelect.bind(this)}>{AppConfig.SETTINGS_VEHICLE_NAMES.Bus}</MenuItem>
                                        <MenuItem eventKey="3" onSelect={this.handleVehicleSelect.bind(this)}>{AppConfig.SETTINGS_VEHICLE_NAMES.Car}</MenuItem>
                                        <MenuItem eventKey="4" onSelect={this.handleVehicleSelect.bind(this)}>{AppConfig.SETTINGS_VEHICLE_NAMES.FireEngine}</MenuItem>
                                        <MenuItem eventKey="5" onSelect={this.handleVehicleSelect.bind(this)}>{AppConfig.SETTINGS_VEHICLE_NAMES.PoliceCar}</MenuItem>
                                        <MenuItem eventKey="6" onSelect={this.handleVehicleSelect.bind(this)}>{AppConfig.SETTINGS_VEHICLE_NAMES.Taxi}</MenuItem>
                                    </DropdownButton>
                                </Col>
                            </FormGroup> : null
                        }
                        <FormGroup controlId="formHorizontalPassword">
                            <Col className="settingsLabel" sm={2}>
                                <OverlayTrigger
                                    trigger={['hover', 'focus']}
                                    key="themeOverlay"
                                    placement="top"
                                    overlay={
                                        <Popover id="popover-positioned-top">The stat is shown in the top left of the game</Popover>
                                    }>
                                    <span>Stat</span>
                                </OverlayTrigger>
                            </Col>
                            <Col sm={10}>
                                <DropdownButton
                                    bsStyle="default"
                                    title={this.state.settings.stat}
                                    className="whiteDropdown"
                                    key="themeDropdown"
                                    id="dropdown-basic-default"
                                    >

                                    <MenuItem eventKey="1" onSelect={this.handleStatSelect.bind(this)}>{AppConfig.SETTINGS_STAT_NAMES.Barrels}</MenuItem>
                                    <MenuItem eventKey="2" onSelect={this.handleStatSelect.bind(this)}>{AppConfig.SETTINGS_STAT_NAMES.Economy}</MenuItem>
                                    <MenuItem eventKey="3" onSelect={this.handleStatSelect.bind(this)}>{AppConfig.SETTINGS_STAT_NAMES.Efficiency}</MenuItem>
                                    <MenuItem eventKey="4" onSelect={this.handleStatSelect.bind(this)}>{AppConfig.SETTINGS_STAT_NAMES.Fire}</MenuItem>
                                    <MenuItem eventKey="5" onSelect={this.handleStatSelect.bind(this)}>{AppConfig.SETTINGS_STAT_NAMES.Health}</MenuItem>
                                    <MenuItem eventKey="6" onSelect={this.handleStatSelect.bind(this)}>{AppConfig.SETTINGS_STAT_NAMES.Money}</MenuItem>
                                    <MenuItem eventKey="7" onSelect={this.handleStatSelect.bind(this)}>{AppConfig.SETTINGS_STAT_NAMES.Oil}</MenuItem>
                                    <MenuItem eventKey="8" onSelect={this.handleStatSelect.bind(this)}>{AppConfig.SETTINGS_STAT_NAMES.People}</MenuItem>
                                    <MenuItem eventKey="9" onSelect={this.handleStatSelect.bind(this)}>{AppConfig.SETTINGS_STAT_NAMES.Popularity}</MenuItem>
                                    <MenuItem eventKey="10" onSelect={this.handleStatSelect.bind(this)}>{AppConfig.SETTINGS_STAT_NAMES.Satisfaction}</MenuItem>
                                    <MenuItem eventKey="11" onSelect={this.handleStatSelect.bind(this)}>{AppConfig.SETTINGS_STAT_NAMES.Security}</MenuItem>
                                    <MenuItem eventKey="12" onSelect={this.handleStatSelect.bind(this)}>{AppConfig.SETTINGS_STAT_NAMES.Speed}</MenuItem>
                                    <MenuItem eventKey="13" onSelect={this.handleStatSelect.bind(this)}>{AppConfig.SETTINGS_STAT_NAMES.Weight}</MenuItem>
                                </DropdownButton>
                            </Col>
                        </FormGroup>

                        <FormGroup controlId="formHorizontalPassword">
                            <Col className="settingsLabel" sm={2}>
                                <OverlayTrigger
                                    trigger={['hover', 'focus']}
                                    key="themeOverlay"
                                    placement="top"
                                    overlay={
                                        <Popover id="popover-positioned-top">Stat prefix. E.g. you might want £ if your players are earning money</Popover>
                                    }>
                                    <span>Stat Prefix</span>
                                </OverlayTrigger>
                            </Col>
                            <Col sm={10}>
                                <FormControl className="settingsInput" placeholder="Score Prefix (e.g. £)" onChange={this.onUpdateSettingsPrefix.bind(this)} value={this.state.settings.prefix} />
                            </Col>
                        </FormGroup>

                        <FormGroup controlId="formHorizontalPassword">
                            <Col className="settingsLabel" sm={2}>
                                <OverlayTrigger
                                    trigger={['hover', 'focus']}
                                    key="themeOverlay"
                                    placement="top"
                                    overlay={
                                        <Popover id="popover-positioned-top">Stat suffix. E.g. you might want % if your players are earning health</Popover>
                                    }>
                                    <span>Stat Suffix</span>
                                </OverlayTrigger>
                            </Col>
                            <Col sm={10}>
                                <FormControl className="settingsInput" placeholder="Score Suffix (e.g. %)" onChange={this.onUpdateSettingsSuffix.bind(this)} value={this.state.settings.suffix} />
                            </Col>
                        </FormGroup>

                        <FormGroup controlId="formHorizontalPassword">
                            <Col className="settingsLabel" sm={2}>
                                <OverlayTrigger
                                    trigger={['hover', 'focus']}
                                    key="themeOverlay"
                                    placement="top"
                                    overlay={
                                        <Popover id="popover-positioned-top">Define how much health, money etc your players start with</Popover>
                                    }>
                                    <span>Starting Stat</span>
                                </OverlayTrigger>
                            </Col>
                            <Col sm={10}>
                                <FormControl className="settingsInput" placeholder="Max stat (e.g. 100)" onChange={this.onUpdateSettingsStartingStat.bind(this)} value={this.state.settings.startingStat} />
                            </Col>
                        </FormGroup>

                        <FormGroup controlId="formHorizontalPassword">
                            <Col className="settingsLabel" sm={2}>
                                <OverlayTrigger
                                    trigger={['hover', 'focus']}
                                    key="themeOverlay"
                                    placement="top"
                                    overlay={
                                        <Popover id="popover-positioned-top">Default is 0. What's the lowest stat your players can reach before gameover</Popover>
                                    }>
                                    <span>Lowest Stat</span>
                                </OverlayTrigger>
                            </Col>
                            <Col sm={10}>
                                <FormControl className="settingsInput" placeholder="Min stat (e.g. 0)" onChange={this.onUpdateSettingsMinStat.bind(this)} value={this.state.settings.minStat} />
                            </Col>
                        </FormGroup>

                        <FormGroup controlId="formHorizontalPassword">
                            <Col className="settingsLabel" sm={2}>
                                <OverlayTrigger
                                    trigger={['hover', 'focus']}
                                    key="themeOverlay"
                                    placement="top"
                                    overlay={
                                        <Popover id="popover-positioned-top">What's the highest stat your players can reach. E.g for health it's probably 100. For money it might be near unlimited. Only the best players should be able to achieve this.</Popover>
                                    }>
                                    <span>Max Stat</span>
                                </OverlayTrigger>
                            </Col>
                            <Col sm={10}>
                                <FormControl className="settingsInput" placeholder="Max stat (e.g. 100)" onChange={this.onUpdateSettingsMaxStat.bind(this)} value={this.state.settings.maxStat} />
                            </Col>
                        </FormGroup>

                        <FormGroup>
                            <Col smOffset={2} sm={10}>
                                <Button onClick={this.saveSettings.bind(this)} disabled={!this.state.canSave} className="saveBtn">Save</Button>
                            </Col>
                        </FormGroup>
                        </Form>
                </div>

                <div className='settingsGroup'>
                    <Form horizontal>
                        <FormGroup controlId="formHorizontalEmail">
                            <Col className="settingsLabel" sm={2}>
                                <OverlayTrigger
                                    trigger={['hover', 'focus']}
                                    key="themeOverlay"
                                    placement="top"
                                    overlay={
                                        <Popover id="popover-positioned-top">Intro header for the game splash screen</Popover>
                                    }>
                                    <span>Intro Header</span>
                                </OverlayTrigger>
                            </Col>
                            <Col sm={10}>
                                <FormControl className="settingsInput" placeholder="Add intro header" onChange={this.onUpdateintroHeader.bind(this)} value={this.state.text.landing.subHeading} />
                            </Col>
                        </FormGroup>

                        <FormGroup controlId="formHorizontalPassword">
                            <Col className="settingsLabel" sm={2}>
                                <OverlayTrigger
                                    trigger={['hover', 'focus']}
                                    key="themeOverlay"
                                    placement="top"
                                    overlay={
                                        <Popover id="popover-positioned-top">Intro title for the game splash screen</Popover>
                                    }>
                                    <span>Intro Title</span>
                                </OverlayTrigger>
                            </Col>
                            <Col sm={10}>
                                <FormControl className="settingsInput" placeholder="Add title" onChange={this.onUpdateIntroTitle.bind(this)} value={this.state.text.landing.title} />
                            </Col>
                        </FormGroup>

                        <FormGroup controlId="formHorizontalPassword">
                            <Col className="settingsLabel" sm={2}>
                                <OverlayTrigger
                                    trigger={['hover', 'focus']}
                                    key="themeOverlay"
                                    placement="top"
                                    overlay={
                                        <Popover id="popover-positioned-top">Intro description for the game splash screen</Popover>
                                    }>
                                    <span>Intro Description</span>
                                </OverlayTrigger>
                            </Col>
                            <Col sm={10}>
                                <FormControl className="settingsInput" placeholder="Add short description" onChange={this.onUpdateIntroDescription.bind(this)} value={this.state.text.landing.description} />
                            </Col>
                        </FormGroup>

                        <FormGroup>
                            <Col smOffset={2} sm={10}>
                                <Button onClick={this.saveSettings.bind(this)} disabled={!this.state.canSave} className="saveBtn">Save</Button>
                            </Col>
                        </FormGroup>
                    </Form>
                </div>

                <div className='settingsGroup'>
                    <Form horizontal>
                        <FormGroup controlId="formHorizontalEmail">
                            <Col className="settingsLabel" sm={2}>
                                <OverlayTrigger
                                    trigger={['hover', 'focus']}
                                    key="themeOverlay"
                                    placement="top"
                                    overlay={
                                        <Popover id="popover-positioned-top">What message should be shown if the player successfully completes the game</Popover>
                                    }>
                                    <span>Game Ending (Success)</span>
                                </OverlayTrigger>
                            </Col>
                            <Col sm={10}>
                                <FormControl className="settingsInput" placeholder="Add game ending (success) text" onChange={this.onUpdateGameEndingSuccess.bind(this)} value={this.state.text.game.gameOver} />
                            </Col>
                        </FormGroup>

                        <FormGroup controlId="formHorizontalPassword">
                            <Col className="settingsLabel" sm={2}>
                                <OverlayTrigger
                                    trigger={['hover', 'focus']}
                                    key="themeOverlay"
                                    placement="top"
                                    overlay={
                                        <Popover id="popover-positioned-top">What message should be shown if the player dies/fails in the game</Popover>
                                    }>
                                    <span>Game Ending (Fail)</span>
                                </OverlayTrigger>
                            </Col>
                            <Col sm={10}>
                                <FormControl className="settingsInput" placeholder="Add game ending (fail) text" onChange={this.onUpdateGameEndingFail.bind(this)} value={this.state.text.game.playerDied} />
                            </Col>
                        </FormGroup>

                        <FormGroup>
                            <Col smOffset={2} sm={10}>
                                <Button onClick={this.saveSettings.bind(this)} disabled={!this.state.canSave} className="saveBtn">Save</Button>
                            </Col>
                        </FormGroup>
                    </Form>
                </div>
{/* 
                impactScoreValues:ImpactScoreValues = {
        tiny: 20,
        small: 50,
        medium: 100,
        large: 250,
        huge: 500,
    };

    impactStatValues:ImpactScoreValues = {
        tiny: 5,
        small: 15,
        medium: 30,
        large: 50,
        huge: 100,
    }; */}

                {/* <div className='settingsGroup'>
                    <Form horizontal>
                        <FormGroup controlId="formHorizontalEmail">
                            <Col className="settingsLabel" sm={2}>
                                Score Tiny
                            </Col>
                            <Col sm={2}>
                                <FormControl className="settingsInput" placeholder="20" onChange={this.onUpdateGameEndingSuccess.bind(this)} value={this.state.settings.impactScoreValues.tiny} />
                            </Col>
                        </FormGroup>
                        <FormGroup controlId="formHorizontalEmail">
                            <Col className="settingsLabel" sm={2}>
                                Score Small
                            </Col>
                            <Col sm={2}>
                                <FormControl className="settingsInput" placeholder="50" onChange={this.onUpdateGameEndingSuccess.bind(this)} value={this.state.settings.impactScoreValues.small} />
                            </Col>
                        </FormGroup>
                        <FormGroup controlId="formHorizontalEmail">
                            <Col className="settingsLabel" sm={2}>
                                Score Medium
                            </Col>
                            <Col sm={2}>
                                <FormControl className="settingsInput" placeholder="100" onChange={this.onUpdateGameEndingSuccess.bind(this)} value={this.state.settings.impactScoreValues.medium} />
                            </Col>
                        </FormGroup>
                        <FormGroup controlId="formHorizontalEmail">
                            <Col className="settingsLabel" sm={2}>
                                Score Large
                            </Col>
                            <Col sm={2}>
                                <FormControl className="settingsInput" placeholder="250" onChange={this.onUpdateGameEndingSuccess.bind(this)} value={this.state.settings.impactScoreValues.large} />
                            </Col>
                        </FormGroup>
                        <FormGroup controlId="formHorizontalEmail">
                            <Col className="settingsLabel" sm={2}>
                                Score Huge
                            </Col>
                            <Col sm={2}>
                                <FormControl className="settingsInput" placeholder="500" onChange={this.onUpdateGameEndingSuccess.bind(this)} value={this.state.settings.impactScoreValues.huge} />
                            </Col>
                        </FormGroup>
                    </Form>
                </div> */}

                <div className='settingsGroup'>
                    <Form horizontal>
                        <FormGroup controlId="formHorizontalEmail">
                            <Col className="settingsLabel" sm={2}>
                                <OverlayTrigger
                                    trigger={['hover', 'focus']}
                                    key="themeOverlay"
                                    placement="top"
                                    overlay={
                                        <Popover id="popover-positioned-top">Stat to be deducted or added for a <strong>Tiny</strong> impact decision</Popover>
                                    }>
                                    <span>Impact Tiny</span>
                                </OverlayTrigger>
                            </Col>
                            <Col sm={2}>
                                <FormControl className="settingsInput" placeholder="5" onChange={this.onUpdateImpactTiny.bind(this)} value={this.state.settings.impactStatValues.tiny} />
                            </Col>
                        </FormGroup>
                        <FormGroup controlId="formHorizontalEmail">
                            <Col className="settingsLabel" sm={2}>
                                <OverlayTrigger
                                    trigger={['hover', 'focus']}
                                    key="themeOverlay"
                                    placement="top"
                                    overlay={
                                        <Popover id="popover-positioned-top">Stat to be deducted or added for a <strong>Small</strong> impact decision</Popover>
                                    }>
                                    <span>Impact Small</span>
                                </OverlayTrigger>
                            </Col>
                            <Col sm={2}>
                                <FormControl className="settingsInput" placeholder="15" onChange={this.onUpdateImpactSmall.bind(this)} value={this.state.settings.impactStatValues.small} />
                            </Col>
                        </FormGroup>
                        <FormGroup controlId="formHorizontalEmail">
                            <Col className="settingsLabel" sm={2}>
                                <OverlayTrigger
                                    trigger={['hover', 'focus']}
                                    key="themeOverlay"
                                    placement="top"
                                    overlay={
                                        <Popover id="popover-positioned-top">Stat to be deducted or added for a <strong>Medium</strong> impact decision</Popover>
                                    }>
                                    <span>Impact Medium</span>
                                </OverlayTrigger>
                            </Col>
                            <Col sm={2}>
                                <FormControl className="settingsInput" placeholder="30" onChange={this.onUpdateImpactMedium.bind(this)} value={this.state.settings.impactStatValues.medium} />
                            </Col>
                        </FormGroup>
                        <FormGroup controlId="formHorizontalEmail">
                            <Col className="settingsLabel" sm={2}>
                                <OverlayTrigger
                                    trigger={['hover', 'focus']}
                                    key="themeOverlay"
                                    placement="top"
                                    overlay={
                                        <Popover id="popover-positioned-top">Stat to be deducted or added for a <strong>Large</strong> impact decision</Popover>
                                    }>
                                    <span>Impact Large</span>
                                </OverlayTrigger>
                            </Col>
                            <Col sm={2}>
                                <FormControl className="settingsInput" placeholder="50" onChange={this.onUpdateImpactLarge.bind(this)} value={this.state.settings.impactStatValues.large} />
                            </Col>
                        </FormGroup>
                        <FormGroup controlId="formHorizontalEmail">
                            <Col className="settingsLabel" sm={2}>
                                <OverlayTrigger
                                    trigger={['hover', 'focus']}
                                    key="themeOverlay"
                                    placement="top"
                                    overlay={
                                        <Popover id="popover-positioned-top">Stat to be deducted or added for a <strong>Huge</strong> impact decision</Popover>
                                    }>
                                    <span>Impact Huge</span>
                                </OverlayTrigger>
                            </Col>
                            <Col sm={2}>
                                <FormControl className="settingsInput" placeholder="100" onChange={this.onUpdateImpactHuge.bind(this)} value={this.state.settings.impactStatValues.huge} />
                            </Col>
                        </FormGroup>
                        <FormGroup>
                            <Col smOffset={2} sm={10}>
                                <Button onClick={this.saveSettings.bind(this)} disabled={!this.state.canSave} className="saveBtn">Save</Button>
                            </Col>
                        </FormGroup>
                    </Form>
                </div>

            </div>
            </Fade>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/SettingsComponent.tsx